import gsap from "gsap";

export default function pageLoading() {
  /***********************************************************************
   * スクロールバー対策
   ***********************************************************************/
  document.documentElement.style.overflowX = "hidden";
  document.body.style.overflowX = "hidden";

  /***********************************************************************
   * 変数・要素取得
   ***********************************************************************/
  const wrapper = document.querySelector('.loading_wrapper');
  const mask = document.querySelector('.loading_mask');
  const isTopPage = document.body.classList.contains('is-top-page');
  const isFirstVisit = !sessionStorage.getItem('visited');

  // 【修正】時間をさらに短縮して、サクサク感を出しつつ「待ち」を無くす
  const enterTime = 0.6;
  const leaveTime = 0.4; // 0.6 → 0.4秒に高速化

  /***********************************************************************
   * 追加：MV関連の要素取得
   ***********************************************************************/
  const mvImg = document.querySelector('.mv_wrapper img');
  const lowerTitleEn = document.querySelector('.mv_title_en'); // 下層英語タイトル
  const lowerTitleJa = document.querySelector('.mv_title_ja'); // 下層日本語タイトル

  /***********************************************************************
   * 1. ロゴ生成
   ***********************************************************************/
  if (mask) {
    if (!mask.querySelector('.js-loading-logo')) {
      const logoHTML = `<div class="loading_logo js-loading-logo"></div>`;
      mask.insertAdjacentHTML('beforeend', logoHTML);
    }
  }
  const logo = mask ? mask.querySelector('.js-loading-logo') : null;
  if (!mask) return;

  /***********************************************************************
   * 2. アニメーション分岐
   ***********************************************************************/

  // 初期化
  gsap.set(wrapper, { autoAlpha: 1 });
  gsap.set(mask, { autoAlpha: 1, animation: "none", animationName: "none" });
  if (logo) gsap.set(logo, { autoAlpha: 1, y: 0 });

  // ▼ 追加：画像の初期状態（少し拡大しておく）
  if (mvImg) {
    gsap.set(mvImg, { scale: 1.1 }); 
  }

  // ▼ 分岐処理 -----------------------------------------------------------
  if (isTopPage && isFirstVisit) {
    // パターンA：トップページ初回
    sessionStorage.setItem('visited', 'true');

    const openingTl = gsap.timeline();

    openingTl
      .to(logo, { autoAlpha: 0, y: -20, duration: 0.6, ease: "power2.in" })
      .to(mask, { autoAlpha: 0, duration: 0.6, ease: "power2.inOut" }, "-=0.2");

    const bgText = document.querySelector('.mv_bg-text');
    const title = document.querySelector('.mv_title');
    const subtitle = document.querySelector('.mv_subtitle');
    const sideHd = document.querySelector('.side-hd');

    if (bgText) {
      gsap.set(bgText, {
        yPercent: -50,
        y: 100,
        autoAlpha: 0
      });
    }
    if (sideHd) gsap.set(sideHd, { x: 100, autoAlpha: 0 });
    if (subtitle) gsap.set(subtitle, { autoAlpha: 0 });
    if (title) gsap.set(title, { y: -30, autoAlpha: 0 });

    openingTl
      // 背景テキスト等のアニメーション
      .to(bgText, {
        yPercent: -50,
        y: 0,
        autoAlpha: 0.4,
        duration: 1.5,
        ease: "power3.out"
      }, "-=0.4")
      // ▼ 追加：画像のズームアウトアニメーション（テキスト出現と合わせる）
      .to(mvImg, {
        scale: 1,
        duration: 2.0, // 少しゆったり戻る
        ease: "power2.out"
      }, "<") // bgText開始と同時
      // タイトルアニメーション
      .to(title, {
        y: 0,
        autoAlpha: 1,
        duration: 1.0,
        ease: "power2.out"
      }, "-=1.5") // 調整：画像アニメーションとの兼ね合いでタイミング調整
      .to(subtitle, {
        autoAlpha: 1,
        duration: 1.2,
        ease: "power1.inOut"
      }, "-=0.6")
      .to(sideHd, {
        x: 0,
        autoAlpha: 1,
        duration: 1,
        ease: "power3.out"
      }, "-=0.8");

  } else {
    // パターンB：通常版（2回目以降 または 下層ページ）
    const enterTl = gsap.timeline();
    
    // ▼ 追加：下層ページのタイトルの初期設定（Topと同じ動き用）
    if(lowerTitleEn) gsap.set(lowerTitleEn, { y: -30, autoAlpha: 0 });
    if(lowerTitleJa) gsap.set(lowerTitleJa, { autoAlpha: 0 });

    enterTl
      .to(logo, { autoAlpha: 0, y: -20, duration: enterTime * 0.6, ease: "power2.in" })
      .to(mask, { autoAlpha: 0, duration: enterTime * 0.6, ease: "power2.inOut" }, "-=0.2");

    // ▼ 追加：画像のズームアウト（マスクが消え始めると同時に開始）
    if(mvImg) {
      enterTl.to(mvImg, {
        scale: 1,
        duration: 1.5,
        ease: "power2.out"
      }, "-=0.4");
    }

    // ▼ 追加：下層ページのタイトルアニメーション（Topの動きを踏襲）
    if(lowerTitleEn) {
      enterTl.to(lowerTitleEn, {
        y: 0,
        autoAlpha: 1,
        duration: 1.0,
        ease: "power2.out"
      }, "-=1.0"); // 画像が動き出してから追随
    }
    if(lowerTitleJa) {
      enterTl.to(lowerTitleJa, {
        autoAlpha: 1,
        duration: 1.2,
        ease: "power1.inOut"
      }, "-=0.6");
    }
  }

  /***********************************************************************
   * 3. 離脱時（Leave）
   ***********************************************************************/
  const loadingAnimation = (url) => {
    const leaveTl = gsap.timeline({
      onComplete: () => {
        window.location.href = url;
      }
    });

    leaveTl
      .to(mask, {
        autoAlpha: 1,
        duration: leaveTime,
        ease: "power2.out"
      })
      .fromTo(logo,
        { autoAlpha: 0, y: 15 },
        {
          autoAlpha: 1,
          y: 0,
          duration: leaveTime,
          ease: "power2.out"
        },
        "<"
      );
  };

  /***********************************************************************
   * 4. クリック監視
   ***********************************************************************/
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a');
    if (!anchor || !anchor.href) return;
    if (anchor.target && anchor.target !== '_self') return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    const hrefAttr = anchor.getAttribute('href');
    if (hrefAttr.startsWith('#') || hrefAttr.startsWith('tel:') || hrefAttr.startsWith('mailto:')) return;
    if (anchor.hostname !== window.location.hostname) return;
    if (hrefAttr.match(/\.(jpg|jpeg|png|gif|webp|pdf)$/i)) return;

    e.preventDefault();
    loadingAnimation(anchor.href);
  }, false);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
}